import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { Button, Form, Select, DatePicker, Input, Layout, Row, Col } from 'antd'
import { observer, inject } from 'mobx-react'
import moment from 'moment'
import { inquiryStatus } from '@texts/inquiries'
import * as styles from '../../../App/index.scss'

const Option = Select.Option

@inject((store: any) => {
    const { inquiries } = store

    return {
        inquiries
    }
})
@observer
class IndexSearch extends ComponentExt<any> {
    updateFilter = (e, filterName) => {
        this.props.inquiries.updateFilters({ ...this.props.inquiries.filters, [filterName]: e })
    }
    updateAndChange = (e, filterName) => {
        this.updateFilter(e, filterName)
        this.updateList()
    }
    updateList = () => {
        this.props.inquiries.getInquiries({ pageIndex: 1 })
    }
    render() {
        return (
            <div className="box">
                <div className="search">
                    <Form>
                        <Layout>
                            <Row gutter={3}>
                                <Col xs={4}>
                                    <Select
                                        className={styles.input}
                                        placeholder={`סינון לפי מצב פניה`}
                                        onChange={e => this.updateAndChange(e, 'status')}
                                    >
                                        <Option key={0} value={null}>
                                            כל הפניות
                                        </Option>
                                        <Option key={1} value={'WAITING'}>
                                            {inquiryStatus.WAITING}
                                        </Option>
                                        <Option key={2} value={'FOLLOWUP'}>
                                            {inquiryStatus.FOLLOWUP}
                                        </Option>
                                        <Option key={3} value={'APPROVAL'}>
                                            {inquiryStatus.APPROVAL}
                                        </Option>
                                        <Option key={4} value={'PROGRESS'}>
                                            {inquiryStatus.PROGRESS}
                                        </Option>
                                        <Option key={5} value={'DONE'}>
                                            {inquiryStatus.DONE}
                                        </Option>
                                    </Select>
                                </Col>
                                <Col xs={4}>
                                    <Select
                                        className={styles.input}
                                        placeholder={`סינון לפי תעדוף`}
                                        onChange={e => this.updateAndChange(e, 'priority')}
                                    >
                                        <Option key={0} value={null}>
                                            כל הפניות
                                        </Option>
                                        <Option key={1} value={1}>
                                            פניות בעדיפות גבוהה
                                        </Option>
                                        <Option key={2} value={2}>
                                            פניות בעדיפות בינונית
                                        </Option>
                                        <Option key={3} value={3}>
                                            פניות בעדיפות נמוכה
                                        </Option>
                                    </Select>
                                </Col>
                                <Col xs={4}>
                                    <DatePicker.RangePicker
                                        style={{ direction: 'ltr' }}
                                        format="DD/MM/YYYY"
                                        separator="|"
                                        placeholder={['From date', 'To date']}
                                        onChange={e => {
                                            const dates = { from: moment(e[0]).unix(), to: moment(e[1]).unix() }
                                            this.updateAndChange(dates, 'dateRange')
                                        }}
                                    />
                                </Col>
                                <Col xs={4}>
                                    <Input
                                        key={`assigned-to-user`}
                                        placeholder="סינון לפי נציג מטפל"
                                        className={styles.input}
                                        onChange={e => this.updateFilter(e.target.value || null, 'assignedUser')}
                                    />
                                </Col>
                                <Col xs={4}>
                                    <Input
                                        key={`assigned-to-customer`}
                                        placeholder="סינון לפי לקוח"
                                        className={styles.input}
                                        onChange={e => this.updateFilter(e.target.value || null, 'assignedCustomer')}
                                    />
                                </Col>
                                <Col xs={4}>
                                    <Button onClick={this.updateList} className={styles.input} icon="search">
                                        חפש
                                    </Button>
                                </Col>
                            </Row>
                        </Layout>
                    </Form>
                </div>
            </div>
        )
    }
}

export default Form.create()(IndexSearch)
